import template from './rail-cancel-rebook-mode-modal.html';
import railAmendmentSuccessTemplate from './rails-amendment-success.html';
import {railStates} from './../ukrail-routes';
import {tripStates} from './../../trip/trip-routes';
import RailRebookSuccessModalController from './rail-rebook-success-modal-controller';

export default function RailAmendmentService(
    $state,
    $q,
    $stateParams,
    $http,
    modalService,
    userService,
    railsApiService,
    tripApprovalService,
) {
    'ngInject';

    Object.assign(this, {
        initAmendmentMode,
        unsubscribeFromRebookMode,
        isAmendmentMode,
        createRailRebookCandidate,
        createEuRailRebookCandidate,
        navigateToCheckoutWithNewRailGroup,
        getJourneyEligibility,
        showAmendmentSuccessPopup,
        getAmendmentParameters,
        getEuRailsJourneyChangeables,
    });

    let unsubscribeHandler;

    const {TRIP_DETAILS, CHECKOUT} = tripStates;
    const WHITELISTED_STATES = [railStates.RESULTS, railStates.EUROPEANRESULTS, TRIP_DETAILS, CHECKOUT];
    const modalSize = 'md';

    function isAmendmentMode() {
        return !!$stateParams.rebook;
    }

    function unsubscribeFromRebookMode() {
        unsubscribeHandler();
    }

    function getJourneyEligibility(railRecommendationId, tripId) {
        return railsApiService.getJourneyEligibility(railRecommendationId, tripId)
            .then(({Eligibility, RailGroups}) => {
                const railGroupStatuses = {};
                if (RailGroups) {
                    RailGroups.forEach(({Id, CanBeAmendedStatus}) =>
                        railGroupStatuses[Id] = CanBeAmendedStatus);
                }
                return {railGroupStatuses, Eligibility};
            });
    }


    function getEuRailsJourneyChangeables(railRecommendationId, tripId) {
        return railsApiService.getEuRailsJourneyChangeables(railRecommendationId, tripId);
    }

    function initAmendmentMode(rootScope, railsFactory) {
        unsubscribeHandler = rootScope.$on('$stateChangeStart', handleStateChange);

        function handleStateChange(event, toState) {
            if ($stateParams.rebook && !WHITELISTED_STATES.includes(toState.name)) {
                event.preventDefault();
                modalService.openModal({template, size: modalSize})
                    .result
                    .then(() => {
                        unsubscribeHandler();
                        $stateParams.rebook = null;
                        railsFactory.resetParams();
                        $state.go(toState.name);
                    });
            }
        }
    }

    async function createRailRebookCandidate(basketRail, rebook) {
        const railRecommendation = {
            SearchId: basketRail.searchId,
            OutwardJourneyId: basketRail.outwardJourneyId,
            OutwardTicketId: basketRail.outwardJourneyTicketId,
            ReturnJourneyId: basketRail.ReturnJourneyId,
            ReturnTicketId: basketRail.ReturnJourneyTicketId,
            ReturnOrSingle: basketRail.ReturnOrSingle,
            AddOns: basketRail.AddOns,
            TicketDeliveryOptionType: basketRail.TicketDeliveryOptionType,
            DeliveryDetails: basketRail.DeliveryDetails,
            OutSeatPreference: basketRail.OutSeatPreference,
            ReturnSeatPreference: basketRail.ReturnSeatPreference,
            TicketDeliveryOptionFee: basketRail.TicketDeliveryOptionFee,
            OutOfPolicyStatus: basketRail.OutOfPolicyStatus,
        };

        const payload = {
            AreTicketsCollected: rebook.areTicketsCollected,
            RejectedRailGroupId: rebook.rejectedGroupId,
            CreateTripItemRailRequest: railRecommendation,
        };

        return $http.apiPOST('/trips/CreateRailRecommendation', payload)
            .then(({data}) => data);
    }

    function createEuRailRebookCandidate(selection, rebook) {
        const payload = {
            railRecommendationId: rebook.railRecommendationId,
            tripId: rebook.tripId,
            originalSectionId: rebook.selectedChangeable.SectionId,
            journeyId: selection.journeyId,
            alternativeIds: selection.alternativeIds,
        };

        return $http.apiPOST('/trips/CreateEuRailRecommendation', payload)
            .then(({data}) => data);
    }

    function navigateToCheckoutWithNewRailGroup(newRailRecommendationId, tripId) {
        if (!$stateParams.rebook) {
            $stateParams.rebook = {};
        }
        Object.assign($stateParams.rebook, {
            newRailRecommendationId,
        });
        $state.go(tripStates.CHECKOUT, {
            id: tripId,
            department: userService.getCurrentDepartment(),
            rebook: $stateParams.rebook,
        });
    }

    function showAmendmentSuccessPopup(tripDetails, tripData) {
        const areTicketsCollected = $stateParams.rebook.isEuRails ? false : tripDetails.Rails[0].RailGroups.AreTicketsCollected;

        return modalService.openModal({
            template: railAmendmentSuccessTemplate,
            controller: RailRebookSuccessModalController,
            controllerAs: '$ctrl',
            resolve: {
                areTicketsCollected: () => areTicketsCollected,
                isAmendmentSentForApproval: () => tripApprovalService.isApprovalProcess(tripData, true),
                tripId: () => tripDetails.Id,
            },
        }).result
            .then(endAmendmentProcess);
    }

    function endAmendmentProcess() {
        $stateParams.rebook = null;
    }

    function getAmendmentParameters() {
        const recommendationId = $stateParams.rebook && $stateParams.rebook.newRailRecommendationId;

        if (recommendationId) {
            return {recommendationId, isEuRails: $stateParams.rebook.isEuRails};
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/rail-amendment/rail-amendment-service.js